'use strict';

angular.module('broadcastsModule')

.config(function ($stateProvider, resourceStateProvider)
{

    resourceStateProvider.state('admin.broadcasters', {
        title: 'Broadcasters',
        url: 'broadcasters',
        model: 'Broadcast',
        viewOptions: 'broadcastsViewOptions',
        query: ['folder_id'],
        params: { folder_id: '0' },
        edit: {
            controller: 'MediaEditCtrl',
            templateUrl: 'ng-komondor-media-library/media.edit.html',
            resolve: {
                actions: ['Action', function (Action) {
                                    return Action.findAll();
                                }],
                files: ['BroadcastsFile', 'modalState', function (BroadcastsFile, modalState) {
                                    var params = { broadcast_id: modalState.stateParams.id };
                                    BroadcastsFile.ejectAll(params);
                
                                    return BroadcastsFile.findAll(params);
                                }],
                assetTypes: function assetTypes() {
                    return ['folder', 'image', 'video', 'audio'];
                }
            }
        },
        move: true
    });
})